<div class="login-modal-overlay">
    <div class="login-modal">
        <div class="modal-header">
            <div class="logo">
                <img alt="Rooftop Logo" height="50"
                     ngSrc="cms/rooftop_logo_1ab581168f.webp" width="200">
            </div>
            <button (click)="close()" aria-label="Close modal" class="close-btn">×</button>
        </div>
        <div class="modal-body">
            <form (ngSubmit)="sendOtp()" *ngIf="!otpSent" [formGroup]="loginForm">
                <div class="form-group">
                    <label for="phone">Phone Number</label>
                    <div class="phone-input-container">
                        <ngx-intl-tel-input
                            [enableAutoCountrySelect]="true"
                            [enablePlaceholder]="true"
                            [maxLength]="15"
                            [numberFormat]="PhoneNumberFormat.National"
                            [phoneValidation]="true"
                            [preferredCountries]="preferredCountries"
                            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                            [searchCountryFlag]="true"
                            [selectFirstCountry]="false"
                            [selectedCountryISO]="CountryISO.India"
                            [separateDialCode]="separateDialCode"
                            formControlName="phone"
                            id="phone">
                        </ngx-intl-tel-input>
                    </div>
                </div>
                <button (click)="sendOtp()" [disabled]="loginForm.invalid || isSendingOtp" class="btn btn-primary"
                        type="submit">
                    <span *ngIf="!isSendingOtp">Send OTP</span>
                    <span *ngIf="isSendingOtp" class="loader"></span>
                </button>
            </form>
            <form (ngSubmit)="verifyOtp()" *ngIf="otpSent" [formGroup]="otpForm">
                <div class="form-group">
                    <label for="otp-0" id="otp-label">Enter OTP</label>
                    <div aria-labelledby="otp-label" class="otp-inputs">
                        <input #otpInput
                               (input)="onOtpInput($event, i)"
                               (keydown)="onOtpKeydown($event, i)"
                               (paste)="onOtpPaste($event)"
                               *ngFor="let i of [0,1,2,3,4,5]"
                               [attr.aria-label]="'OTP digit ' + (i + 1)"
                               [id]="'otp-' + i"
                               class="otp-input"
                               maxlength="1"
                               placeholder="0"
                               type="tel">
                    </div>
                </div>
                <p>Time remaining: {{ timer }} seconds</p>
                <p class="resend-text">Didn't receive the code?
                    <a (click)="resendOtp()" [class.disabled]="!resendEnabled">Resend</a>
                </p>
                <div *ngIf="errorMessage" aria-live="polite" class="error-message">{{ errorMessage }}</div>
                <button [disabled]="otpForm.invalid || isVerifyingOtp" class="btn btn-primary" type="submit">
                    <span *ngIf="!isVerifyingOtp">Verify OTP</span>
                    <span *ngIf="isVerifyingOtp" class="loader"></span>
                </button>
            </form>
        </div>
        <div class="recaptcha-container" id="recaptcha-container"></div>
    </div>
</div>
